/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { ListGcpNetworksResponseNetworksInner } from '../models/ListGcpNetworksResponseNetworksInner';

export class ListGcpNetworksResponse {
  /**
  * The available networks
  */
  'networks': Array<ListGcpNetworksResponseNetworksInner>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "networks",
      "baseName": "networks",
      "type": "Array<ListGcpNetworksResponseNetworksInner>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListGcpNetworksResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

